var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 4.66667H4.67333M4.66667 2H8C8.34133 2 8.68267 2.13 8.94267 2.39067L13.6093 7.05733C13.8593 7.30737 13.9997 7.64645 13.9997 8C13.9997 8.35355 13.8593 8.69263 13.6093 8.94267L8.94267 13.6093C8.69263 13.8593 8.35355 13.9997 8 13.9997C7.64645 13.9997 7.30737 13.8593 7.05733 13.6093L2.39067 8.94267C2.26667 8.81901 2.16833 8.67208 2.10128 8.51031C2.03424 8.34854 1.99982 8.17511 2 8V4.66667C2 3.95942 2.28095 3.28115 2.78105 2.78105C3.28115 2.28095 3.95942 2 4.66667 2Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagOutline);
export default __webpack_public_path__ + "static/media/TagOutline.4ddc591d7cb7d90b1994edaf71bcb9fa.svg";
export { ForwardRef as ReactComponent };